import React from "react";
import { Link } from "react-router-dom";
import "./Home.css"; // Make sure this path matches your CSS file location

const Home = () => {
  return (
    <div className="page active">
      {/* Slideshow Section */}
      <div className="hero-slideshow">
        <div className="hero-overlay">
          <div className="hero">
            <h2>Welcome to</h2>
            <h1>Devanshi Corporation</h1>
            <p>
              Your Trusted Partner in the Import of Industrial Chemicals Since
              2000
            </p>
            <Link to="/products" className="cta-button">
              Browse Products
            </Link>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="features">
        <div className="feature-card">
          <div className="feature-icon">🏭</div>
          <h3>Industrial Excellence</h3>
          <p>
            Leading importer and supplier of high-quality industrial chemicals
            and specialty products for diverse industries.
          </p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">🚚</div>
          <h3>Reliable Supply Chain</h3>
          <p>
            Efficient logistics and distribution network ensuring timely
            delivery across India with multiple shipping options.
          </p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">✅</div>
          <h3>Quality Assurance</h3>
          <p>
            Verified company with stringent quality control measures and
            certified products meeting industry standards.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
